import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { Lock, Zap, Shield, CreditCard } from 'lucide-react';
export function CTASection() {
  return <section className="px-6 py-5 max-w-4xl mx-auto text-center" data-id="element-189">
      <FadeIn data-id="element-190">
        <div className="bg-white rounded-3xl p-6 md:p-10 shadow-xl border border-[#4A5D3A]/10 max-w-2xl mx-auto" data-id="element-191">
          <CTAButton className="mb-8 py-6 text-xl md:text-2xl" data-id="element-192">
            SÍ — QUIERO APAGAR EL RUIDO MENTAL ESTA NOCHE
          </CTAButton>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left text-sm md:text-base text-[#2D2A26]/80" data-id="element-193">
            <div className="flex items-center gap-3" data-id="element-194">
              <Lock className="text-[#4A5D3A] shrink-0" size={20} data-id="element-195" />
              <span data-id="element-196">
                <strong data-id="element-197">Pago 100% seguro</strong> procesado por Hotmart
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-198">
              <Zap className="text-[#C4A265] shrink-0" size={20} data-id="element-199" />
              <span data-id="element-200">
                <strong data-id="element-201">Acceso instantáneo</strong> — en menos de 2 minutos
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-202">
              <Shield className="text-[#4A5D3A] shrink-0" size={20} data-id="element-203" />
              <span data-id="element-204">
                <strong data-id="element-205">Garantía de 7 días</strong> — cero riesgo
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-206">
              <CreditCard className="text-[#9B4F2B] shrink-0" size={20} data-id="element-207" />
              <span data-id="element-208">
                <strong data-id="element-209">Solo $6.39 USD</strong> — menos que un café
              </span>
            </div>
          </div>
        </div>
      </FadeIn>
    </section>;
}